import { LOCALES } from '../../locales';
import { generalFormI18n } from '../shared/form.i18n';

export default {
  [LOCALES.ENG]: {
    ...generalFormI18n[LOCALES.ENG],
    
    //dashboard
    admin_dashboard_developers: 'Developers',
    admin_dashboard_applications: 'Applications',
    admin_dashboard_reports: 'Reports',
    //tabs
    admin_tab_new_request: 'New Requests',
    admin_tab_active: 'Active',
    admin_tab_deactivated: 'Deactivated',
    admin_tab_onboarding: 'Onboarding',
    admin_tab_pending: 'Pending',
    admin_tab_registered: 'Registered',
    admin_tab_aproved: 'Approved',
    admin_tab_published: 'Published',
    admin_tab_description: 'Description',
    admin_tab_technical_details: 'Technical Details',
    admin_tab_documentations: 'Documentation',
    admin_tab_personal_profile: 'Personal Profile',
    admin_tab_partner_profile: 'Partner Profile',
    admin_tab_apps: 'Apps',
    admin_country: 'Country',
    admin_website: 'Website',
    admin_company_name: 'Company Name',
    admin_city: 'City',
    admin_state: 'State',
    admin_post_code: 'Postal Code',
    admin_description: 'Description',
    admin_address: 'Address',

    //navigations bar
    admin_dashboard_link_developers: 'Developers {value}',
    admin_dashboard_link_developers_details: 'Developers',
    admin_dashboard_link_applications: 'Apps {value}',
    admin_dashboard_link_applications_details: 'Apps',
    admin_dashboard_link_application: 'App details',
    admin_dashboard_dev_profile: 'Dev Profile',
    //header
    admin_navigation_platform: 'Dashboard',
    admin_api_documentation: 'Api Documentation',
    admin_design_system: 'Design System',
    admin_application_gallery: 'Application Gallery',
    admin_my_account: 'My Account',
    admin_logout: 'Log out',
    //table
    admin_dev_table_company: 'Company',
    admin_dev_table_email_address: 'Developer Contact',
    admin_dev_table_name: 'Name',
    admin_dev_table_email: 'Email',
    admin_dev_table_phone: 'Mobile',
    admin_dev_table_registration_date: 'Registration Date',
    admin_dev_table_activation_date: 'Activation Date',
    admin_dev_table_deactivation_date: 'Deactivation Date',
    admin_dev_table_onboarding_date: 'Onboarding Date',
    admin_dev_table_solution: 'Solution',
    admin_dev_table_application_status: 'Application Status',
    admin_dev_table_category: 'Category',
    admin_dev_table_type: 'Type',
    admin_table_paginations: 'Items per page',
    admin_table_send_for_review_date: 'Send for review date',
    admin_table_date_of_approval: 'Date of approval',
    admin_table_date_of_publishing: 'Date of publishing',
    admin_table_date_of_deactivation: 'Date of deactivation',
    admin_table_date_of_registration: 'Date of registration ',
    //button
    admin_cancel_btn: 'Cancel',
    admin_change_status_btn: '{value}',
    admin_approve_btn: 'Approve',
    admin_send_to_rework_btn: 'Send to Rework',
    admin_activate_status: 'Activate',
    admin_publish_status: 'Publish',
    admin_decline_status: 'Decline',
    admin_deactivate_status: 'Deactivate',
    admin_register_status: 'Register',
    admin_onboarding_status: 'Onboarding',
    //dialog text
    admin_change_status_dialog_header: '{value} Developer',
    admin_activate_dialog_value: 'activate',
    admin_decline_dialog_value: 'decline',
    admin_deactivate_dialog_value: 'deactivate',
    admin_status_dialog_header: '{value} Developer',
    admin_change_status_dialog_text: 'Please confirm if you want to {value} developer {name}',
    admin_app_status_dialog_header: '{value} application!',
    admin_DEACTIVATED_status: 'Deactivate',
    admin_PUBLISHED_status: 'Activate',
    admin_READYTOPUBLISH_status: 'Publish',
    admin_PUBLISHED_dialog_value: 'Please confirm if you want to activate {value} application',
    admin_DEACTIVATED_dialog_value: 'Please confirm if you want to deactivate {value} application',
    admin_READYTOPUBLISH_dialog_value: 'Please confirm if you want to publish {value} application',
    admin_cant_be_activated:
      'The application can`t be activated, it lacks required field(s). All required fields should be filled in by the developer before the activation',
    admin_sucsses_deactivated: 'Application Deactivation Successful',
    admin_sucsses_activated: 'Application Activation Successful',
    admin_success_published: 'Application Publish Successful!',
    admin_cant_be_published:
      'The application can`t be published, it lacks required field(s). All required fields should be filled in by the developer before publish',

    //pages
    admin_description_app_img: 'App Image',
    admin_description_name: 'Name',
    admin_description_type: 'Type',
    admin_description_url: 'Informational URL',
    admin_description_category: 'Category',
    admin_description_intended_users: 'Intended Users',
    admin_description_intended_purpose: 'Intended Purpose',
    admin_description_short_description: 'Short Description',
    admin_description_long_descriptions: 'Long Description',
    admin_description_preview_images: 'Preview images',
    admin_works_with: 'Works With',
    admin_portal: 'Developer Platform',
    //documentation
    admin_tab_doc_details_content_title: 'Tutorials and Documentation',
    admin_tab_doc_details_content_subtitle_license: 'EULA (End User License Agreements) ',
    //developer-details
    admin_first_name: 'First Name',
    admin_last_name: 'Last Name',
    admin_phone: 'Phone',
    //footer
    admin_footer_terms_of_service: 'Terms of Service',
    admin_footer_privacy_policy: 'Privacy Policy'
  },
};
